export default class StyleSheet {
  constructor (prefix, columnWidths) {
    if (!columnWidths) columnWidths = [];

    this.stylesheet = document.createElement("style");
    document.head.appendChild(this.stylesheet);

    for (let x = 0; x < 100; x++) {
      this.stylesheet.sheet.insertRule(`${prefix} .cell-${x} { width: ${ columnWidths[x] || 100 }px }`);
    }
  }
}
